var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"modal"}},[_c('div',{staticClass:"modal-content modal-dialog-centered"},[_c('div',{staticClass:"overlaylogin",attrs:{"id":"overlaylogin"}},[_c('div',{staticClass:"modal-customLogin"},[_c(_vm.component,_vm._b({tag:"component"},'component',_vm.$attrs,false))],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }